import React from 'react';
import { FormattedMessage } from 'react-intl';
import { loupe_medium } from '@dnb/eufemia/icons';
import { navigate } from 'gatsby';
import {MenuButton} from '@dnb/header';

const SearchButton = () => {
  return (
      <MenuButton
        text={<FormattedMessage id="dnb_header_search_button" />}
        icon={loupe_medium}
        on_click={() => navigate('/')}
        disabled // TODO: Enable once search is implemented
      />
  );
};

export default SearchButton;
